export default __webpack_public_path__ + "2e5020352e6f3a8e9c9f29a481a4f2a5.svg";